import { useEffect, useState } from "react";
import { Select, Transfer, message } from "antd";
import { getAllRoleGroups } from "../services/roleGroupService";
import {
  getRolesByRoleGroupId,
  addRoleToRoleGroup,
  deleteRoleFromRoleGroup
} from "../services/roleGroupRoleService";
import { getAllRoles } from "../services/roleService";
import { toast } from "react-toastify";

const RoleGroupRoles = () => {
  const [roleGroups, setRoleGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [allRoles, setAllRoles] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAssigned, setCurrentAssigned] = useState([]);

  const fetchGroups = async () => {
    try {
      const result = await getAllRoleGroups();
      setRoleGroups(result);
    } catch {
      message.error("Rol grupları alınamadı.");
    }
  };

  const fetchGroupRoles = async (groupId) => {
    try {
      setLoading(true);
      const [allRolesResult, assignedRolesResult] = await Promise.all([
        getAllRoles(),
        getRolesByRoleGroupId(groupId)
      ]);

      const assignedIds = assignedRolesResult.map(role => role.id);

      setAllRoles(allRolesResult);
      setTargetKeys(assignedIds);
      setCurrentAssigned(assignedIds);
    } catch (error) {
      message.error("Rol bilgileri alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleGroupChange = (groupId) => {
    setSelectedGroupId(groupId);
    fetchGroupRoles(groupId);
  };

  const handleTransferChange = async (newTargetKeys) => {
    const added = newTargetKeys.filter(x => !currentAssigned.includes(x));
    const removed = currentAssigned.filter(x => !newTargetKeys.includes(x));

    for (const roleId of added) {
      const dto = {
        roleGroupId: selectedGroupId,
        roleId: roleId
      };
      const result = await addRoleToRoleGroup(dto);
      if (result?.Status) {
        toast.success(result.Message || "Rol eklendi");
      } else {
        toast.error(result.Message || "Rol eklenemedi");
      }
    }

    for (const roleId of removed) {
      const dto = {
        RoleGroupId: selectedGroupId,
        RoleId: roleId
      };
      const result = await deleteRoleFromRoleGroup(dto);
      if (result?.Status) {
        toast.success(result.Message || "Rol çıkarıldı");
      } else {
        toast.error(result.Message || "Rol çıkarılamadı");
      }
    }

    setTargetKeys(newTargetKeys);
    setCurrentAssigned(newTargetKeys);
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return (
    <div>
      <h2>Rol Grubu Rolleri</h2>
      <Select
        style={{ width: 300, marginBottom: 16 }}
        placeholder="Rol Grubu Seçiniz"
        onChange={handleGroupChange}
        value={selectedGroupId}
        options={roleGroups.map(g => ({ label: g.name, value: g.id }))}
      />

      {selectedGroupId && (
        <Transfer
          dataSource={allRoles}
          titles={['Atanmamış', 'Atanmış']}
          targetKeys={targetKeys}
          onChange={handleTransferChange}
          rowKey={item => item.id}
          render={item => item.name}
          listStyle={{ width: 300, height: 400 }}
          loading={loading}
        />
      )}
    </div>
  );
};

export default RoleGroupRoles;
